import { useMemo } from 'external/react'
import {
   Fade
  ,Box
  ,styled
} from 'external/material'
import { chunk } from 'external/lodash'
import useMenu from 'hooks/menu'
import useStudentContext from 'hooks/student'
import { useWindowSize } from 'hooks/window-size'
import { drawerWidth, courseItemWidth, courseItemHeight, courseItemMargin, maxCoursesPerRow } from 'settings'

import CourseItem from './Item'

const courseItemBasis = courseItemWidth + courseItemMargin

const Row = styled(Box)(rowStyles)
const Item = styled(Box)(itemStyles)

export default function Courses() {
  const {groups} = useStudentContext()
  const {open} = useMenu()
  const {width: windowWidth} = useWindowSize()
  const containerStyles = {
    padding: '0 30px',
    width: '100%',
    marginTop: 10,
    marginBottom: 10,
    display: 'flex',
    justifyContent: 'center'
  }

  const coursesPerRow = useMemo(() => {
    const effectiveWidth = (open ? windowWidth - drawerWidth : windowWidth) - courseItemMargin
    return Math.min(Math.floor(effectiveWidth / courseItemBasis), maxCoursesPerRow)
  }, [open, windowWidth])
  
  const fillersNeeded = useMemo(() => {
    const fillersNeeded = coursesPerRow - groups.length % coursesPerRow
    return fillersNeeded == coursesPerRow ? 0 : fillersNeeded
  }, [coursesPerRow, groups.length])

  const rows = useMemo(() => {
    const chunks = chunk(groups, coursesPerRow)
    return fillersNeeded > 0
      ? chunks.map(row =>
        row.length < coursesPerRow
        ? row.concat(Array(fillersNeeded).fill({dummy: true}))
        : row)
      : chunks
  }, [groups, coursesPerRow, fillersNeeded])

  return (<Box sx={containerStyles}>
    <Fade in={groups.length > 0}>
      <Box sx={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
        {rows.map((groups, index) => {
          return (<Row key={index}>{groups.map((group, index) => {
            return group.dummy
              ? (<Item key={index} sx={{width: courseItemWidth, height: courseItemHeight}} />)
              : (<Item key={index}><CourseItem group={group} /></Item>)
          })}</Row>)
        })}
      </Box>
    </Fade>
  </Box>
  )
}

function rowStyles() {
  return {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: '50px',
    '&:first-of-type': {
      marginTop: 0
    }
  } 
}

function itemStyles() {
   return {
    marginLeft: courseItemMargin,
    '&:first-of-type': {
      marginLeft: 0
    }
   } 
}